import { render, staticRenderFns } from "./psychosocial-risk-factors-form.vue?vue&type=template&id=26e6e478&"
import script from "./psychosocial-risk-factors-form.vue?vue&type=script&lang=js&"
export * from "./psychosocial-risk-factors-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports